import { render, staticRenderFns } from "./cmpdetalhesprodutos.vue?vue&type=template&id=6bd1092c&"
import script from "./cmpdetalhesprodutos.vue?vue&type=script&lang=js&"
export * from "./cmpdetalhesprodutos.vue?vue&type=script&lang=js&"
import style0 from "./cmpdetalhesprodutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports